import { useSelector } from 'react-redux';

const useGlobalUnreadCount = () => {
  const { selectedGig, newMessageCounts, selectedChat, newDmMessageCounts } = useSelector(
    state => state.chat
  );

  const gigUnreadCount = Object.entries(newMessageCounts || {}).reduce((sum, [gigId, count]) => {
    if (selectedGig?.id?.toString() === gigId.toString()) return sum;
    return sum + count;
  }, 0);

  const dmUnreadCount = Object.entries(newDmMessageCounts || {}).reduce((sum, [chatId, count]) => {
    if (selectedChat?.id?.toString() === chatId.toString()) return sum;
    return sum + count;
  }, 0);

  return gigUnreadCount + dmUnreadCount;
};

export default useGlobalUnreadCount;
